export default __webpack_public_path__ + "static/media/ETEF-2-3.790b0500.pdf";